import { Outlet } from 'react-router-dom';

import { GameSettingsNav } from './game-settings-nav.js';

export function GameSettingsLayout(): JSX.Element {
  // h-full + overflow-hidden so the AppShell <main> doesn't scroll the whole
  // layout - we want the nav to sit still while the content area scrolls.
  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden md:flex-row">
      <GameSettingsNav />
      <div className="min-w-0 flex-1 overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
}
